import type { DialogContent } from '@/components/FormResultDialog/FormResultDialog';
import type { FrontifyImageContent } from '@/contentful';
import { ViewportSize } from '@/styles/viewportSize';
import type { ActionModalCF, LeadCreatedModalCF } from '@/types';

import { getFrontifyBackgroundImageUrl } from './frontify';

export const isActionModal = (
  object: ActionModalCF | LeadCreatedModalCF
): object is ActionModalCF => {
  return object.sys.contentType.sys.id === 'actionModal';
};

export const getLeadFormDialogContent = (
  leadModalContent: ActionModalCF | LeadCreatedModalCF | undefined,
  isMdOrLarger: boolean
): DialogContent | ActionModalCF | undefined => {
  if (!leadModalContent) return undefined;

  if (isActionModal(leadModalContent)) {
    return leadModalContent;
  }

  return {
    title: leadModalContent.fields.title || '',
    subtitle: leadModalContent.fields.subtitle || '',
    details: leadModalContent.fields.action || '',
    imagePath:
      Array.isArray(leadModalContent?.fields?.modalImage) &&
      leadModalContent.fields.modalImage.length > 0
        ? getFrontifyBackgroundImageUrl(
            leadModalContent.fields
              .modalImage[0] as unknown as FrontifyImageContent,
            isMdOrLarger ? ViewportSize.xl : ViewportSize.md
          )
        : '',
  };
};
